import { createFileRoute } from '@tanstack/react-router';

import { approvalsOperatorsScreen, loadApprovalsMessages, loadApprovalsOperatorsScreen, operatorsSearch } from '@/modules/approvals/route';
import { lazyScreen } from '@/shared/screen';

// Mesmo caminho do legado (router.tsx:732-742): sem aba no hub, só por URL, com `BankAccount:ViewPendingOperators` e raiz.
export const Route = createFileRoute('/_app/aprovacoes/gestao-aprovacoes/operadores')({
  validateSearch: operatorsSearch,
  staticData: { screen: approvalsOperatorsScreen },
  loader: () => loadApprovalsMessages(),
  component: lazyScreen(loadApprovalsOperatorsScreen, 'ApprovalsOperatorsScreen'),
});
